module.exports = __webpack_public_path__ + "img/coffee.4571a2a0.svg";